import { Avatar as MatAvatar } from "@mui/material";

function Avatar(props: { alt: string; src?: string }) {
  const { alt, src = " " } = props;

  return <MatAvatar alt={alt} src={src !== "" ? src : " "} variant="rounded" />;
}

export default Avatar;
